import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import request from 'superagent';
import {Tabs} from 'antd';
import moment from 'moment';
import Loading from '../../commons/Loading.js';

class PlatformInfoView extends Component {

    state = {
        data: [],
        vmData: [],
        ctData: [],
        loading: false,
        showContainerID:''
    };

    fetch = () => {
        this.setState({loading: true});
        request.get('/api/dashboard/platform/info')
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    let data = response.body;
                    let cpuArray = [];
                    for (let i = 0; i < data.length; i++) {
                        data[i].resourceType = data[i].resourceType.toUpperCase();
                        data[i].used_percent = Math.round(data[i].used_percent) + '%';
                        data[i].startTime4Show = moment(data[i].startTime).format("YYYY-MM-DD HH:mm:ss");
                        if (data[i].resourceType === 'CPU') {
                            cpuArray.push(data[i]);
                        }
                    }
                    let vmData = [];
                    for (let i = 0; i < cpuArray.length; i++) {
                        let vmTemp = {
                            hostName: cpuArray[i].hostName,
                            cpu: cpuArray[i].used_percent,
                            container:[],
                            containerCPU:'',
                            containerMEN:'',
                            containerBack:false
                        }
                        for (let j = 0; j < data.length; j++) {
                            if (data[j].hostName === vmTemp.hostName && data[j].resourceType === 'DISK') {
                                vmTemp.disk = data[j].used_percent;
                            } else if (data[j].hostName === vmTemp.hostName && data[j].resourceType === 'MEM') {
                                vmTemp.memory = data[j].used_percent;
                            } else if (data[j].hostName === vmTemp.hostName && (data[j].resourceType === 'DOCKER_CONTAINER_CPU' || data[j].resourceType === 'DOCKER_CONTAINER_MEM')) {
                                if (!vmTemp.container.includes(data[j].containerID)) {
                                    vmTemp.container.push(data[j].containerID);
                                }
                            }
                        }
                        vmTemp.container4show = vmTemp.container.toString();
                        vmData.push(vmTemp);
                    }
                    this.setState({
                        loading: false,
                        data: data,
                        vmData: vmData
                    });
                }
            });
    }

    componentDidMount() {
        this.fetch();
    }

    containerBackFormatter = (cell, row, enumObject) => {
        return (
            <div style={{display: cell ? 'block' : 'none'}}><a href="#" onClick={ () => this.hideContainer(row)}>Back</a></div>
        )
    }
    hideContainer = (row) => {
        let vmData = this.state.vmData;
        for (let i = 0; i < vmData.length; i++) {
            vmData[i].containerCPU = '';
            vmData[i].containerMEN = '';
            vmData[i].containerBack = false;
        }
        this.setState({
            showContainerID: '',
            vmData: vmData
        });
    }
    containerFormatter = (cell, row, enumObject) => {
        const listItems = row.container.map((container) =>
            <a href="#" onClick={ ()=> this.showContainer(row, container)} key={container}>{container}</a>
        );
        return (
            <div style={{display: 'grid'}}>{listItems}</div>
        )
    }

    showContainer = (row, showContainerID) => {
        let hostName = row.hostName;
        let data = this.state.data;
        let vmData = this.state.vmData;
        let showContainerCPU = '';
        let showContainerMEM = '';
        for (let i = 0; i < data.length; i++) {
            if (data[i].hostName === hostName && data[i].containerID === showContainerID) {
                if (data[i].resourceType === 'DOCKER_CONTAINER_CPU') {
                    showContainerCPU = data[i].used_percent;
                } else if (data[i].resourceType === 'DOCKER_CONTAINER_MEM') {
                    showContainerMEM = data[i].used_percent;
                }
            }
        }
        for (let i = 0; i < vmData.length; i++) {
            if (vmData[i].hostName === hostName) {
                vmData[i].containerCPU = showContainerCPU;
                vmData[i].containerMEN = showContainerMEM;
                vmData[i].containerBack = true;
            } else {
                vmData[i].containerCPU = '';
                vmData[i].containerMEN = '';
                vmData[i].containerBack = false;
            }
        }
        this.setState({
            showContainerID: showContainerID,
            vmData: vmData
        });
    }

    render() {
        const vmData = this.state.vmData;
        const showContainerID = this.state.showContainerID;
        const options = {
            noDataText: this.state.loading ? <Loading /> : <div>No alert found.</div>,
            searchDelayTime: 500
        };
        return (
        <div>
            <h2 className="page-title">System Usage</h2>
            <Tabs type="card">
                <Tabs.TabPane tab="Virtual Machine" key="1">
                    <div className=''>
                        <BootstrapTable data={ vmData } search={ true } options={ options } striped hover condensed>
                            <TableHeaderColumn dataField='hostName' isKey dataSort={ true }  width="28%">Host Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='cpu' dataSort={ true } width="5%" hidden={showContainerID !== ''}>cpu</TableHeaderColumn>
                            <TableHeaderColumn dataField='disk' dataSort={ true } width="5%" hidden={showContainerID !== ''}>disk</TableHeaderColumn>
                            <TableHeaderColumn dataField='memory' dataSort={ true } width="7%" hidden={showContainerID !== ''}>memory</TableHeaderColumn>
                            <TableHeaderColumn dataField='container4show' dataSort={ true } dataFormat={ this.containerFormatter }>container</TableHeaderColumn>
                            <TableHeaderColumn dataField='containerCPU' dataSort={ true } width="5%" hidden={showContainerID === ''}>CPU</TableHeaderColumn>
                            <TableHeaderColumn dataField='containerMEN' dataSort={ true } width="7%" hidden={showContainerID === ''}>memory</TableHeaderColumn>
                            <TableHeaderColumn dataField='containerBack' dataSort={ true } width="5%" dataFormat={ this.containerBackFormatter } hidden={showContainerID === ''}></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Container" key="2">
                    Container
                </Tabs.TabPane>
            </Tabs>
        </div>

        );
    }
}

export default PlatformInfoView;


// WEBPACK FOOTER //
// ./src/modules/system-usage/PlatformInfoView.js